

    try {
      
            var sizeModal = new tingle.modal({
        closeLabel: 'Cerrar',
        onClose: function() {
            console.log('close');
        },
        onOpen: function() {
            console.log('open');
        },
        beforeOpen: function() {
            console.log('before open');
        },
        beforeClose: function() {
            console.log('before close');
            return true;
        },
        cssClass: ['o-msi-table', 'class2']
        });
        var btn = document.querySelector('.o-product-size-help__label');
        btn.addEventListener('click', function(){
            sizeModal.open();
        });
        sizeModal.setContent(document.querySelector('.o-size-table').innerHTML);


    }
    catch(err) {
      
    }



    try {
      
        var productTitleHelp = new tingle.modal({
        closeLabel: 'Cerrar',
        onClose: function() {
            console.log('close');
        },
        onOpen: function() {
            console.log('open');
        },
        beforeOpen: function() {
            console.log('before open');
        },
        beforeClose: function() {
            console.log('before close');
            return true;
        },
            cssClass: ['o-msi-table', 'class2']
        });
        var btn = document.querySelector('.o-product-title__help');
        btn.addEventListener('click', function(){
            productTitleHelp.open();
        });
        productTitleHelp.setContent(document.querySelector('.o-title-help-modal').innerHTML);

    }
    catch(err) {
      
    }



    
    

   

    

    



